import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AccountList = styled.ul``

export const AccountGroup = styled.li`
  margin-bottom: ${Spacing.S16};
`
